import { useEffect, useState } from "react";
import { EditUserDataType } from "../../Enums/EditUserDataType";
import { isValidPassword, passwordRequirementsMessage } from "../../Utils/passwordValidator";
import { FaEnvelope, FaLock, FaTimes } from "react-icons/fa";
import FloatingInput from "../FloatingInput/FloatingInput";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";

type EditUserDataModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (data: any) => void;
  method?: EditUserDataType;
};

const EditUserDataModal = ({
  isOpen,
  onClose,
  onSuccess,
  method
}: EditUserDataModalProps) => {
  const [newEmail, setNewEmail] = useState<string>("");
  const [confirmNewEmail, setConfirmNewEmail] = useState<string>("");
  const [currentPassword, setCurrentPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const passwordTooltip = passwordRequirementsMessage.trim();

  useEffect(() => {
    if (isOpen) {
      resetFields();
    }
  }, [isOpen]);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const handleSubmit = async () => {
    if (method === EditUserDataType.Email) {
      if (newEmail !== confirmNewEmail) {
        setErrorMessage("Emails não conferem.");
        return;
      }

    }

    if (method === EditUserDataType.Password && !isValidPassword(newPassword)) {
      setErrorMessage(passwordTooltip);
      return;
    }

    onSuccess({
      newEmail,
      confirmNewEmail,
      currentPassword,
      newPassword
    });
    handleClose();
  };

  const resetFields = () => {
    setNewEmail("");
    setConfirmNewEmail("");
    setCurrentPassword("");
    setNewPassword("");
    setErrorMessage("");
  };

  const handleClose = () => {
    resetFields();
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal overlayClassName="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white rounded-md shadow-xl px-6 py-9 relative w-full max-w-3xl">
        <button 
          onClick={handleClose} 
          className="absolute top-4 right-4 text-primary-600 hover:text-primary-700 text-2xl font-bold"
        >
          <FaTimes />
        </button>

        <div className="flex flex-col items-center justify-center gap-4">
          {method === EditUserDataType.Email && (
            <FaEnvelope className="text-primary-600 text-xl" />
          )}

          {method === EditUserDataType.Password && (
            <FaLock className="text-primary-600 text-xl" />
          )}
              
          <h4 className="text-lg font-bold">
            {method === EditUserDataType.Email && "ALTERAR E-MAIL"}
            {method === EditUserDataType.Password && "ALTERAR SENHA"}
          </h4>  

          <div className="w-full flex flex-col items-center justify-center gap-2">
            <p>
              {`Preencha os campos abaixo para realizar a alteração ${method === EditUserDataType.Email ? "do seu e-mail" : method === EditUserDataType.Password ? "da sua senha" : ""}:`}
            </p>

            {method === EditUserDataType.Email && (
              <>
                <FloatingInput
                  label={"Digite seu novo e-mail"}
                  name="email"
                  type = "email"
                  value={newEmail}
                  onChange={e => setNewEmail(e.target.value)}
                  required
                />

                <FloatingInput
                  label={"Confirme seu novo e-mail"}
                  name="confirmNewEmail"
                  type = "email"
                  value={confirmNewEmail}
                  onChange={e => setConfirmNewEmail(e.target.value)}
                  required
                />

                <FloatingInput
                  label={"Digite sua senha"}
                  name="currentPassword"
                  type="password"
                  value={currentPassword}
                  onChange={e => setCurrentPassword(e.target.value)}
                  required
                />
              </>
            )}

            {method === EditUserDataType.Password && (
              <>
                <FloatingInput
                  label={"Digite sua senha atual"}
                  name="currentPassword"
                  type = "password"
                  value={currentPassword}
                  onChange={e => setCurrentPassword(e.target.value)}
                  required
                />

                <FloatingInput
                  label={"Digite a nova senha"}
                  name="newPassword"
                  type = "password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  required
                  tooltip={passwordTooltip}
                />

              </>
            )}          
          </div>

          {errorMessage && (
            <p className="text-primary-600 text-xs sm:text-sm">{errorMessage}</p>
          )}
          
          <Button 
            onClick={handleSubmit} 
            className="block mx-auto px-16 py-2"
          >
            {"CONFIRMAR"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditUserDataModal;
